import featuredOffers120x90 from './FeaturedOffers120x90';

export default featuredOffers120x90;
